import { FC } from 'react';
import './index.scss';

import { DrawerActions, DrawerWrapper } from '../../../components/Menu/styledComponents';
import { Close } from '../../Assets/svgIcons';
import Text from '../Text';

interface CustomDrawerProperties {
	Content: FC<{ onClose: () => void }>;
	HelperButton?: FC;
	MainButton?: FC;
	isSecondary?: boolean;
	label: string;
	onClose: () => void;
	open: boolean;
}

const CustomDrawer = ({
	onClose,
	open,
	label,
	Content,
	MainButton,
	HelperButton,
	isSecondary = false,
}: CustomDrawerProperties) => (
	<DrawerWrapper
		variant="temporary"
		anchor="right"
		open={open}
		onClose={onClose}
		PaperProps={{
			style: {
				overflow: 'auto',
			},
		}}
	>
		<div className="drawerHeader">
			<Text title={label} type="h6" fontWeight="semiBold" />
			<Close onClick={onClose} />
		</div>
		<div className={`drawerContent ${isSecondary ? 'secondary' : ''}`}>
			<Content onClose={onClose} />
		</div>
		<DrawerActions>
			{HelperButton && <HelperButton />}
			{MainButton && <MainButton />}
		</DrawerActions>
	</DrawerWrapper>
);

export default CustomDrawer;
